module.exports = __webpack_public_path__ + "img/undraw_impressora.f329087f.svg";